import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionsLayoutModule } from './transactions-layout/transactions-layout.module';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CorePipesModule, OdinCoreModule } from '@odin/odin-core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { PeblTrackingDetailsComponent } from './pebl-tracking-details/pebl-tracking-details.component';
import { PeblScheduleDetailsComponent } from './pebl-schedule-details/pebl-schedule-details.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { RefundTransactionModalComponent } from './transactions-layout/components/refund-transaction-modal/refund-transaction-modal.component';
import { RechargeTransactionModalComponent } from './transactions-layout/components/recharge-transaction-modal/recharge-transaction-modal.component';
import { ReverseTransactionModalComponent } from './transactions-layout/components/reverse-transaction-modal/reverse-transaction-modal.component';
import { CompleteTransactionModalComponent } from './transactions-layout/components/complete-transaction-modal/complete-transaction-modal.component';
import { CallbackTransactionModalComponent } from './transactions-layout/components/callback-transaction-modal/callback-transaction-modal.component';
import { AccountSelectorComponent } from './transactions-layout/components/account-selector/account-selector.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatChipsModule,
    MatTooltipModule,
    MatDividerModule,
    ScrollingModule,
    OdinCoreModule,
    CorePipesModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    TransactionsLayoutModule,
  ],
  exports: [
    AccountSelectorComponent,
    ReverseTransactionModalComponent,
    RefundTransactionModalComponent,
    RechargeTransactionModalComponent,
    CompleteTransactionModalComponent,
    PeblTrackingDetailsComponent,
    PeblScheduleDetailsComponent,
    CallbackTransactionModalComponent,
  ],
  providers: [],
  declarations: [
    AccountSelectorComponent,
    ReverseTransactionModalComponent,
    RefundTransactionModalComponent,
    RechargeTransactionModalComponent,
    CompleteTransactionModalComponent,
    PeblTrackingDetailsComponent,
    PeblScheduleDetailsComponent,
    CallbackTransactionModalComponent
  ],
})
export class OdinTransactionsModule {}
